var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageDeliveryOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.65416,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "none",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26C15.1818 26 14.4002 25.6646 12.8369 24.9939C8.94564 23.3243 7 22.4895 7 21.0853V11.7475M16 26C16.8182 26 17.5998 25.6646 19.1631 24.9939C23.0544 23.3243 25 22.4895 25 21.0853V11.7475M16 26V16.1707M7 11.7475C7 12.3513 7.80157 12.7325 9.40472 13.495L12.3259 14.8844C14.1288 15.7419 15.0303 16.1707 16 16.1707M7 11.7475C7 11.1438 7.80157 10.7625 9.40472 10M25 11.7475C25 12.3513 24.1984 12.7325 22.5953 13.495L19.6741 14.8844C17.8712 15.7419 16.9697 16.1707 16 16.1707M25 11.7475C25 11.1438 24.1984 10.7625 22.5953 10M10.332 17.311L12.3259 18.2594",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6V8M20 7L18.5 9M12 7L13.5 9",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageDeliveryOutline);
export default __webpack_public_path__ + "static/media/packageDeliveryOutline.431d7404fd004d5cf6a7352ca0be82f9.svg";
export { ForwardRef as ReactComponent };